import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { updateType, search } from '../../state/actions';
import { StateType } from '../../../state/reducers';

const mapState = ({ queryParams }: StateType) => ({
  hasQuery: queryParams.userQuery.length > 0,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onTypeChanged(type: keyof StateType['results']['counts'], hasQuery: boolean) {
    dispatch(updateType(type));

    if (hasQuery) {
      dispatch(search({ reason: 'type_changed' }));
    }
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
